import React, { useState, useEffect } from "react";
import moment from "moment";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { getJDCalendarDatesOfMonth } from "../../services/dataService";
import { jdCalenderFilter, standerdDate } from "../../utils/dataFilter";
import { MonthlyDetailDataTile } from "./MonthlyDetailTile";
import {
  getMonthlyShipmentActualProgress,
  getMonthlyShipmentActualProgressForAggregate,
  getMonthlyShipmentActualProgressFor5M,
  DetailedMonthlyTractorShipmentActualData,
  getMonthlyContainerPlanning
} from "../../services/tractorDataService";
import { DetailedMonthlyAggregateShipmentActualData, getAggregateMonthlyContainerPlanning } from "../../services/aggregateDataService";
import { DetailedMonthly5MShipmentActualData } from "../../services/fiveMDataService";
import { filter } from "lodash";
import { Modal } from "react-bootstrap";


function MonthlyPlanViewer({
  monthlyData,
  selectedDate,
  setSelectedDate,
  selectedMonth,
  setSelectedMonth,
  firstKey,
  secondKey,
  dataType,
  setMonthlyData,
  selectedFilter,
}) {
  const [calendar, setCalendar] = useState([]);
  const [jdMonthDates, setJdMonthDates] = useState([]);
  const [monthlyActualData, setMonthlyActualData] = useState({});
  const [monthlyActualDetailData, setMonthlyActualDetailData] = useState({});
  const [monthlyActualRawDetailDataOf5M, setMonthlyActualRawDetailDataOf5M] = useState({});
  const [monthlyDataAsPerDate, setMonthlyDataAsPerDate] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [iframeDate, setIframeDate] = useState(null);


  const filteredMonthlyActualData = filter(monthlyActualDetailData, {
    Date: moment(selectedDate).format("DD-MM-YY"),
  });
  useEffect(() => {
    async function getMonthlyShipmentActualProgressData() {
      try {
        if (dataType === "Tractor") {
          const actualResponse = await getMonthlyShipmentActualProgress(
            moment(selectedMonth).format("YYYY-MM")
          );
          setMonthlyActualData(actualResponse);
          const actualDetailedResponse =
            await DetailedMonthlyTractorShipmentActualData(
              moment(selectedMonth).format("MMM-YY")
            );
          setMonthlyActualDetailData(actualDetailedResponse);
          const response = await getMonthlyContainerPlanning(
						moment(selectedMonth).format("MMM-YY")
					);
          setMonthlyData(response.data);
        }
        if (dataType === "Aggregate") {
          const actualResponse =
            await getMonthlyShipmentActualProgressForAggregate(
              moment(selectedMonth).format("YYYY-MM")
            );
          setMonthlyActualData(actualResponse);
          const actualDetailedResponse =
            await DetailedMonthlyAggregateShipmentActualData(
              moment(selectedMonth).format("MMM-YY")
            );
          setMonthlyActualDetailData(actualDetailedResponse);
          const response = await getAggregateMonthlyContainerPlanning(
						moment(selectedMonth).format("MMM-YY")
					);
          setMonthlyData(response.data);
        }
        if (dataType === "5M") {
          const actualResponse = await getMonthlyShipmentActualProgressFor5M(
            moment(selectedMonth).format("YYYY-MM")
          );
          setMonthlyActualData(actualResponse);
          const actualDetailedResponse =
            await DetailedMonthly5MShipmentActualData(
              moment(selectedMonth).format("MMM-YY")
            );
            setMonthlyActualRawDetailDataOf5M(actualDetailedResponse);
        }
      } catch (error) {}
    }
    getMonthlyShipmentActualProgressData();
  }, [dataType, selectedMonth, setMonthlyData]);

  useEffect(() => {
    let mounted = true;
    async function getDates() {
      try {
        setJdMonthDates([]);
        const resp = await getJDCalendarDatesOfMonth(
          moment(selectedMonth).format("MMM-YYYY")
        );
        if (mounted) {
          setJdMonthDates(jdCalenderFilter(resp.data));
        }
      } catch (error) {
        setJdMonthDates([]);
      }
    }
    getDates();
    return () => (mounted = false);
  }, [selectedMonth]);

  const getKey = (day) => {
    return `${moment(day).format("MMM")}_${moment(day).format("D")}`;
  };


  const getShipmentCount = (day, data, actualData) => {
    var forecastCount = 0;
    var detailInfo = [];
    for (let i = 0; i < data.length; i++) {
      forecastCount = forecastCount + data[i][`${getKey(day)}`];
      if (data[i][`${getKey(day)}`]) {
        detailInfo.push({
          [firstKey]: data[i][firstKey],
          [secondKey]: data[i][secondKey],
          ShipmentCount: data[i][`${getKey(day)}`],
        });
      }
    }
    const filteredActualData = filter(actualData, {
      date: day.format("YYYY-MM-DD"),
    });
    return {
      forecastCount,
      actualCount: filteredActualData[0],
      information: detailInfo,
    };
  };

  const getClassOfTile = (dayCount) => {
    if (parseInt(dayCount) > 0) return "task task--info";
    return "task task--hide";
  };

  const getClassOfPreviousTile = (dayCount) => {
    if (parseInt(dayCount) > 0) return "task task--previous";
    return "task task--hide";
  };

  useEffect(() => {
    function buildCalendar(date) {
      const a = [];
  
      const startDay = moment(jdMonthDates[0]).clone().startOf("week")
      const endDay = moment(jdMonthDates[jdMonthDates.length - 1]).clone().endOf("week")
  
      const _date = startDay.clone().subtract(1, "day");
  
      while (_date.isBefore(endDay, "day")) {
        a.push(
          Array(7)
            .fill(0)
            .map(() => _date.add(1, "day").clone())
        );
      }
      return a;
    }
    if(jdMonthDates.length > 0 ){
      setCalendar(buildCalendar(selectedMonth));
    }
  }, [selectedMonth, jdMonthDates]);

  function dayStyles(day) {
    if (!jdMonthDates.includes(moment(day).format("D-MMM-YY")))
      return "not-in-month";
    if (selectedDate.isSame(day, "day")) return "selected";
    if (moment(day).isBefore(new Date(), "day")) return "before";
    if (moment(new Date()).isSame(day, "day")) return "today";
    return "";
  }

  function popupPlacement(di) {
    if (di === 1) {
      return "right";
    } else {
      return "left";
    }
  }

function popupClickHandler(day) {
  setSelectedDate(day);
  setIframeDate(day);
  setShowModal(true); // <-- Trigger modal open

  // Collect relevant modal data
  const key = getKey(day);
  const dateStr1 = moment(day).format("YYYY-MM-DD");
  const dateStr2 = moment(day).format("DD-MM-YY");

  const details = monthlyData.map((item) => {
    const planned = item[key] || 0;
    const actualMatch = monthlyActualDetailData.find((d) =>
      d[firstKey] === item[firstKey] &&
      d[secondKey] === item[secondKey] &&
      (d.date === dateStr1 || d.Date === dateStr2)
    );
    const actual = actualMatch?.container_count ?? actualMatch?.ActualCount ?? 0;
    return {
      [firstKey]: item[firstKey],
      [secondKey]: item[secondKey],
      planned,
      actual,
    };
  }).filter((item) => item.planned > 0 || item.actual > 0);

  setModalData(details);
}

  return (
    <>
      <div className="calendar">
        <div className="header">
          <div
            className="previous"
            onClick={() =>
              setSelectedMonth(selectedMonth.clone().subtract(1, "month"))
            }
          >
            <i className="fi-rr-angle-double-small-left"></i>
          </div>
          <div className="current">
            {selectedMonth.format("MMMM")} {selectedMonth.format("YYYY")}
          </div>
          <div
            className="next"
            onClick={() =>
              setSelectedMonth(selectedMonth.clone().add(1, "month"))
            }
          >
            <i className="fi-rr-angle-double-small-right"></i>
          </div>
        </div>

        <div className="body">
          <div className="day-names">
            {["sun", "mon", "tue", "wed", "thu", "fri", "sat"].map((d) => (
              <div className="week" key={d}>
                {d}
              </div>
            ))}
          </div>
          {calendar.map((week, wi) => (
            <div key={wi}>
{week.map((day, di) => {
  const dayDetail = getShipmentCount(day, monthlyData, monthlyActualData);
  return (
    <div
      key={di}
      className={ dayStyles(day) === "not-in-month" ? "day day-disable" : "day" }
      onClick={() => popupClickHandler(day)}
    >
      <div className={dayStyles(day)}>
  {day.format("D")}
  {dayStyles(day) !== "not-in-month" && (
<section
  className={getClassOfTile(dayDetail.forecastCount)}
>
  <span style={{ position: "relative", left: "0" }}>
  Forecasted
  </span>
  <span style={{ marginLeft: "110px" }}>
    {dayDetail.forecastCount}
  </span>
  <br />
  <span style={{ position: "relative", left: "0" }}>
      Planned
  </span>
  <span style={{ marginLeft:  "133px" }}>
    {dayDetail.actualCount
      ? dayDetail.actualCount.container_count
      : 0}
  </span>
   <br />
  <span style={{ position: "relative", left: "0" }}>
    Actual
  </span>
  <span style={{ marginLeft: "145px" }}>
    {dayDetail.actualCount
      ? dayDetail.actualCount.container_count
      : 0}
  </span>
   <br />
  <span style={{ position: "relative", left: "0" }}>
   Dispatch
  </span>
  <span style={{ marginLeft: "130px" }}>
    {dayDetail.actualCount
      ? dayDetail.actualCount.container_count
      : 0}
  </span>
</section>







  )}
</div>

    </div>
  );
})}


            </div>
          ))}
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered dialogClassName="wide-modal">
  <Modal.Header closeButton>
  <Modal.Title>
  <Modal.Title>
  Details for {selectedFilter} – {iframeDate && iframeDate.format("DD MMM YYYY")}
</Modal.Title>

</Modal.Title>

  </Modal.Header>
<Modal.Body>
  {modalData.length > 0 ? (
    <table className="table table-bordered table-striped">
      <thead>
        <tr>
          <th>{firstKey}</th>
          <th>{secondKey}</th>
          <th>Carrier</th>
          <th>Variant</th>
          <th>Container Type</th>
          <th>POL</th>
          <th>POD</th>
          <th>TradeLane</th>
          <th>Forecasted Tractor Count</th>
          <th>Planned Tractor Count</th>
          <th>Forecasted Container Count</th>
          <th>Planned Container Count</th>
          <th>Allocated Container Count</th>
          <th>Dispatched Container Count</th>
          <th>Shortfall/Excess</th>
        </tr>
      </thead>
      <tbody>
        {modalData.map((item, idx) => {
          const shortfall = (item?.Planned_Quantity || 0) - (item?.GateOut_Container_Count || 0);
          return (
            <tr key={idx}>
              <td>{item[firstKey]}</td>
              <td>{item[secondKey]}</td>
              <td>{item.Carrier || "NA"}</td>
              <td>{item.Varient_PartNumber || item.Variant || "NA"}</td>
              <td>{item.Container_Type || "NA"}</td>
              <td>{item.POL || item.Port_Of_Loading || "NA"}</td>
              <td>{item.POD || item.final_destination || "NA"}</td>
              <td>{item.TradeLane || "NA"}</td>
                <td>{item.Planned_Quantity || 0}</td>
              <td>{item.Planned_Quantity || 0}</td>
              <td>{item.Forecasted_Container_Count || item.Planned_Container_Count || 0}</td>
              <td>{item.Planned_Container_Count || 0}</td>
              <td>{item.GateIn_Container_Count || 0}</td>
              <td>{item.GateOut_Container_Count || 0}</td>
              <td style={{ color: shortfall < 0 ? "red" : shortfall > 0 ? "green" : "black", fontWeight: "bold" }}>
                {shortfall}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  ) : (
    <p className="text-muted">No planned or actual data found for this date.</p>
  )}
</Modal.Body>

</Modal>

    </>
  );
}

export default MonthlyPlanViewer;